/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlGrantRequestStatus } from './ControlGrantRequestStatus';
import {
    ControlGrantRequestStatusFromJSON,
    ControlGrantRequestStatusFromJSONTyped,
    ControlGrantRequestStatusToJSON,
} from './ControlGrantRequestStatus';

/**
 * 
 * @export
 * @interface ControlAdminUpdateGrantRequestStatusResponse
 */
export interface ControlAdminUpdateGrantRequestStatusResponse {
    /**
     * 
     * @type {ControlGrantRequestStatus}
     * @memberof ControlAdminUpdateGrantRequestStatusResponse
     */
    request_status: ControlGrantRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminUpdateGrantRequestStatusResponse
     */
    decision_reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdminUpdateGrantRequestStatusResponse
     */
    reviewer: string;
    /**
     * 
     * @type {number}
     * @memberof ControlAdminUpdateGrantRequestStatusResponse
     */
    request_id: number;
}

/**
 * Check if a given object implements the ControlAdminUpdateGrantRequestStatusResponse interface.
 */
export function instanceOfControlAdminUpdateGrantRequestStatusResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "request_status" in value;
    isInstance = isInstance && "reviewer" in value;
    isInstance = isInstance && "request_id" in value;

    return isInstance;
}

export function ControlAdminUpdateGrantRequestStatusResponseFromJSON(json: any): ControlAdminUpdateGrantRequestStatusResponse {
    return ControlAdminUpdateGrantRequestStatusResponseFromJSONTyped(json, false);
}

export function ControlAdminUpdateGrantRequestStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAdminUpdateGrantRequestStatusResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'request_status': ControlGrantRequestStatusFromJSON(json['request_status']),
        'decision_reason': !exists(json, 'decision_reason') ? undefined : json['decision_reason'],
        'reviewer': json['reviewer'],
        'request_id': json['request_id'],
    };
}

export function ControlAdminUpdateGrantRequestStatusResponseToJSON(value?: ControlAdminUpdateGrantRequestStatusResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'request_status': ControlGrantRequestStatusToJSON(value.request_status),
        'decision_reason': value.decision_reason,
        'reviewer': value.reviewer,
        'request_id': value.request_id,
    };
}

